import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/badge'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'

const STATIC_LEGISLATION_COMING_SOON_BASE =
  'v2.pages.products.detail.staticLegislationBriefing.comingSoon'

export function StaticLegislationComingSoonBadge({
  withTooltip = true,
}: {
  withTooltip?: boolean
}) {
  const { t } = useTranslation('common')
  const badge = (
    <Badge
      variant='outline'
      className='border-violet-200 bg-violet-50 font-normal text-violet-800 dark:border-violet-800/50 dark:bg-violet-950/40 dark:text-violet-200'
    >
      {t(`${STATIC_LEGISLATION_COMING_SOON_BASE}.badge`)}
    </Badge>
  )

  if (!withTooltip) {
    return badge
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className='inline-flex' tabIndex={0}>
          {badge}
        </span>
      </TooltipTrigger>
      <TooltipContent side='bottom' className='max-w-sm'>
        {t(`${STATIC_LEGISLATION_COMING_SOON_BASE}.body`)}
      </TooltipContent>
    </Tooltip>
  )
}
